export default __webpack_public_path__ + "static/media/DesktopLine3.8968d6bb.svg";